const ORG = process.env.REACT_APP_ORGANISATION;

export const alignLink = (path: string, isCustomDomain : boolean, organisation?: string) => {
    return !isCustomDomain && organisation ? `/org/${organisation}${path}` : path
};
